import { useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const useBranding = () => {
  const [branding, setBranding] = useState({
    app_name: "",
    app_description: "",
    app_logo: "",
    app_favicon: "",
  });

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await axios.get(`${BACKEND_URL}/api/branding`);
        if (!mounted || !res.data) return;
        setBranding(res.data);
        if (res.data.app_name) document.title = res.data.app_name;
        if (res.data.app_favicon) {
          let link = document.querySelector("link[rel~='icon']");
          if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
          }
          link.href = res.data.app_favicon;
        }
        // PWA: arahkan manifest ke endpoint dinamis (nama & logo dari settings)
        let mlink = document.querySelector("link[rel='manifest']");
        if (!mlink) {
          mlink = document.createElement("link");
          mlink.rel = "manifest";
          document.head.appendChild(mlink);
        }
        mlink.href = `${BACKEND_URL}/api/manifest.webmanifest`;
        // Ikon untuk "Tambahkan ke layar utama" di iOS
        const iconHref = res.data.app_logo || "/icons/icon-192.png";
        let apple = document.querySelector("link[rel='apple-touch-icon']");
        if (!apple) {
          apple = document.createElement("link");
          apple.rel = "apple-touch-icon";
          document.head.appendChild(apple);
        }
        apple.href = iconHref;
        if (res.data.app_name) {
          let ameta = document.querySelector("meta[name='apple-mobile-web-app-title']");
          if (!ameta) {
            ameta = document.createElement("meta");
            ameta.name = "apple-mobile-web-app-title";
            document.head.appendChild(ameta);
          }
          ameta.content = res.data.app_name;
        }
      } catch (e) {
        /* ignore, use defaults */
      }
    })();
    return () => { mounted = false; };
  }, []);

  return branding;
};
